import React from "react";

const DefaultImage = (props) => {
    // It retains only leading numbers and discards all the rest.
    const widthNumber = parseInt(props.width, 10);
    const heightNumber = parseInt(props.height, 10);

    return (
      <svg  width={widthNumber}
            height={heightNumber}
            viewBox={'0 0 ' + widthNumber + ' ' + heightNumber}
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
          <rect
              width={widthNumber}
              height={heightNumber}
              fill="#D9D9D9"
          />
          <path
              d="M15 2.62467H38.0855L96.2735 78.7402V5.57743L126 0V125H99.7521L44.7265 52.4934V125H15V2.62467Z"
              fill="white"
              fillOpacity="0.5"
          />
      </svg>
    );
};

// Set default props
DefaultImage.defaultProps = {
  width: '200px',
  height: '125px'
};

export default DefaultImage;

// --- // Documentation // --- //
/*
import DefaultImage from './../Nano/DefaultImage.js';

<DefaultImage
    width={'200px'}
    height={'125px'}
/>
*/
